export const lighting = {
	shadow600: '0 4px 16px hsla(0, 0%, 100%, 0.16)',
}
